import { $, Disclosure } from '@starberry/components';

import formFields from 'base/defaults/forms/bookViewing.json';

export default {
  component: Disclosure,
  props: {
    render:
      () =>
      ({ isOpen, onClose, onOpen }) => {
        return {
          $: 'Stack',
          props: {
            direction: 'column',
            spacing: 0,
          },
          children: [
            {
              $: 'PrimaryButton',
              props: {
                onClick: () => onOpen,
                mt: 7,
              },
              children: $(
                'constants.translations.bookViewingModal.BOOK_VIEWING_BUTTON_LABEL',
                'Book Viewing'
              ),
            },
            {
              $: 'FormDialog',
              isOpen: isOpen,
              onClose: () => onClose,
              fields: formFields,
            },
          ],
        };
      },
  },
};
